import { Link, useLocation, useParams } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";
import { useAppContext } from "../../../context/AppContext";
import CardEnterprise from "../../../components/cards/CardEnterprise";
import Modal from "../../../components/modal/Modal";
import { useEffect, useState } from "react";
import { getCheckConfigSimulator } from "../../../services/Enterprise/getCheckConfigSImulator";
import { Skeleton } from "primereact/skeleton";
import { useQuery } from "react-query";
import { getIsIB3 } from "../../../utils/auth";
import usePermission from "../../../hooks/usePermission";


export default function EnterpriseSettings() {
  const { id } = useParams();
  const { state } = useLocation();
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  usePermission("16"); //Configurações do Empreendimento

  const [isLoading, setIsLoading] = useState(true);
  const [modalSimulatorConfig, setModalSimulatorConfig] = useState(false);
  const [pendingConfigObject, setPendingConfigObject] = useState(null);

  const pendingConfigLabels = {
    amortizationSystemConfig_financing: {
      name: "Configuração do Sistema de Amortização (Financiamento)",
      route: `/enterpriseSettings/simulator/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 0 }
    },
    discounts_in_cash: {
      name: "Descontos à Vista",
      route: `/enterpriseSettings/simulator/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 1 }
    },
    index_reajust: {
      name: "Índice de Reajuste",
      route: `/enterpriseDetails/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 0 }
    },
    entry: {
      name: "Entrada",
      route: `/enterpriseSettings/simulator/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 2 }
    },
    sale_in_cash: {
      name: "Venda à Vista",
      route: `/enterpriseSettings/simulator/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 1 }
    },
    financing: {
      name: "Financiamento",
      route: `/enterpriseSettings/simulator/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 3 }
    },
    intermediate: {
      name: "Intermediária",
      route: `/enterpriseSettings/simulator/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 4 }
    },
    construction: {
      name: "Parcela de Obra",
      route: `/enterpriseSettings/simulator/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 5 }
    },
    single: {
      name: "Parcela Única",
      route: `/enterpriseSettings/simulator/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 6 }
    },
    teams: {
      name: "Times",
      route: `/enterpriseSettings/teams/${id}`,
      params: { name: state ? state.name : "Empreendimento" }
    },
    blocks: {
      name: `${nomenclature[0].value}`,
      route: `/register/${id}`,
      params: { name: state ? state.name : "Empreendimento" }
    },
    lands: {
      name: `${nomenclature[1].value}`,
      route: `/register/${id}`,
      params: { name: state ? state.name : "Empreendimento" }
    },
    current_account: {
      name: "Conta Corrente",
      route: `/enterpriseDetails/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 1 }
    },
    map_map: {
      name: "Mapa Empreendimento",
      route: `/enterpriseSettings/map/${id}`,
      params: { name: state ? state.name : "Empreendimento", index: 1 }
    }
  };
  const items = [
    {
      template: () => (
        <Link to={`/salesManagement`} className="p-breadcrumb-link">
          {state ? state.name : "Empreendimento"}
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { data: allTrue, isLoading: isAllTrueLoading, isRefetching } = useQuery({
    queryKey: [`checkConfig-${id}`],
    queryFn: () => getCheckConfigSimulator(id),
    retry: false,
  });

  useEffect(() => {
    if (allTrue) {
      const aux = Object.values(allTrue).every(value => value === true);
      // Verifica se todos os valores filtrados são true
      const requiredPermissions = ["88", "89", "93", "105"];

      if (requiredPermissions.every(permission => permissions.includes(permission))) {
        if (!aux) {
          setPendingConfigObject(allTrue);
          setModalSimulatorConfig(true);
        } else {
          setPendingConfigObject(allTrue);
          setTimeout(() => {
            setModalSimulatorConfig(false);
          }, 400);
        } 
      }
      setIsLoading(false);
    }
  }, [allTrue]);

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      {isLoading && (
        <>
          <div className="row d-flex">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="col-xl-3 col-sm-6 pb-3">
                <div
                  className="widget widget-stats bg-gray-400 mb-7px"
                  style={{ height: "100%" }}
                >
                  <div className="stats-icon stats-icon-lg">
                    <Skeleton width="80%" height="100px"></Skeleton>
                  </div>
                  <div className="stats-content">
                    <div className="stats-number">
                      <Skeleton width="50%" height="50px"></Skeleton>
                    </div>
                    <div className="stats-desc pt-3">
                      <div className="stats-link">
                        <Skeleton width="40%" height="10px"></Skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      {!isLoading && (
        <div className="row">
          {permissions && permissions.includes("88") && ( //Configurações do Simulador
            <CardEnterprise
              title="Simulador"
              link={`/enterpriseSettings/simulator/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa fa-gamepad fa-fw"></i>}
              color={"widget widget-stats bg-teal mb-7px"}
            />
          )}
          {permissions && permissions.includes("89") && ( //Editar Mapa
            <CardEnterprise
              title="Mapa"
              link={`/enterpriseSettings/map/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-map-location-dot"></i>}
              color={"widget widget-stats bg-purple mb-7px"}
            />
          )}
          {permissions && permissions.includes("145") && ( // Visualizar Conta Corrente
            <CardEnterprise
              title="Homologação Bancária"
              link={`/banks/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa fa-building-columns fa-fw"></i>}
              color={"widget widget-stats bg-blue mb-7px"}
            />
          )}
          {permissions && permissions.includes("93") && ( //Cadastrar Quadra e Lote 
            <CardEnterprise
              title={`Cadastro ${nomenclature[0].value} e ${nomenclature[1].value}`}
              link={`/register/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-file-invoice-dollar"></i>}
              color={"widget widget-stats bg-pink mb-7px"}
            />
          )}
          {permissions && permissions.includes("109") && ( //Visualizar Modelos de Contrato
            <CardEnterprise
              title="Modelos de Contratos"
              link={`/enterpriseSettings/modelContracts/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-file-contract"></i>}
              color={"widget widget-stats bg-red mb-7px"}
            />
          )}
          {permissions && permissions.includes("101") && ( //Visualizar Times
            <CardEnterprise
              title="Times"
              link={`/enterpriseSettings/teams/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-users"></i>}
              color={"widget widget-stats bg-green mb-7px"}
            />
          )}
          {(permissions?.includes("90")) && ( //Configurar Integração CLicksign 
            <CardEnterprise
              title="ClickSign"
              link={`/clickSignConfig/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-file-signature"></i>}
              color={"widget widget-stats bg-warning mb-7px"}
            />
          )}
          {permissions && permissions.includes("91") && permissions.includes("160") &&  ( //Configurar Modelos de Envio (notificação/email/whatsapp)
            <CardEnterprise
              title="Email"
              link={`/emailShippingDays/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-envelope"></i>}
              color={"widget widget-stats bg-pink-600 mb-7px"}
            />
          )}
          {permissions && permissions.includes("105") && ( //Editar Informações do Empreendimento
            <CardEnterprise
              title="Configurações"
              link={`/enterpriseDetails/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-gears"></i>}
              color={"widget widget-stats bg-dark mb-7px"}
            />
          )}
        </div>
      )}
      <Modal
        visible={modalSimulatorConfig}
        dynamicTitle={`Termine a configuração do seu Empreendimento!`}
        onHide={() => { setModalSimulatorConfig(!modalSimulatorConfig) }}
        closable={true}
      >
        {isRefetching ? (
          <ul className="list">
            <li className="list__item py-2">
              <Skeleton width="80%" height="25px" />
            </li>
            <li className="list__item py-2">
              <Skeleton width="75%" height="25px" />
            </li>
            <li className="list__item py-2">
              <Skeleton width="70%" height="25px" />
            </li>
            <li className="list__item py-2">
              <Skeleton width="70%" height="25px" />
            </li>
            <li className="list__item py-2">
              <Skeleton width="60%" height="25px" />
            </li>
            <li className="list__item py-2">
              <Skeleton width="60%" height="25px" />
            </li>
          </ul>
        ) : (
          <ul className="list">
            {pendingConfigObject && (
              Object.keys(pendingConfigObject)
                .sort((a, b) => pendingConfigObject[a] - pendingConfigObject[b])
                .map((key) => (
                  key !== "apt_simulation" && pendingConfigLabels[key]?.name !== undefined && (
                    <Link key={key} to={pendingConfigLabels[key]?.route} state={pendingConfigLabels[key]?.params} style={{ textDecoration: 'none', color: 'inherit' }} >
                      <li className="list__item hover-card my-2" style={{ cursor: 'pointer' }} test={key}>
                        <i
                          className={`fa-solid ${pendingConfigObject[key] ? 'fa-check text-success' : 'fa-times text-danger'}`}
                          style={{ fontSize: "16px" }}
                        ></i>
                        {` ${pendingConfigLabels[key]?.name}`}{" "}
                        {!pendingConfigObject[key] && (
                          <i className="fa fa-arrow-right text-blue"></i>
                        )}
                      </li>
                    </Link>
                  )
                ))
            )}
          </ul>
        )}
      </Modal>
    </>
  );
}
